
// 排课页
import config from '../config';
import axios from '../utils/fetch';

/**
 * 获取全职的课程信息
 * @param {*} options
 * options.courseId 课程id
 */
export const getFullTimeCourseData = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/cscO2oLessonClientApp/queryPartTimeCourseDetail', {
    pushId: options.courseId,
  });
};

/**
 * 获取兼职的课程信息
 * @param {*} options
 * options.courseId 课程id
 * options.teacherId 老师id
 */
export const getPartTimeCourseData = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/cscO2oLessonClientApp/queryPartTimeOrderDetail', {
    pushId: options.courseId,
    teacherId: options.teacherId,
  });
};

/**
 * 同意接课
 * @param {*} options
 * options.courseId 课程id
 * options.teacherId 老师id
 */
export const receiveCourse = (options) => {
  return axios.get('/api/lesson-service/autoCoursesArrangingService/doneCourse', {
    id: options.courseId,
    source: 3,
  });
};

/**
 * 拒绝接课
 * @param {*} options
 * options.courseId 课程id
 * options.teacherId 老师id
 * options.type 拒绝类型
 * options.reason 拒绝理由
 */
export const refuseCourse = (options) => {
  return axios.post('/api/lesson-service/autoCoursesArrangingService/refuseCourse', {
    id: options.courseId,
    type: options.type,
    refuseReason: options.reason,
    source: 3,
  });
};

/**
 * 抢课
 * @param {*} options
 * options.courseId 课程id
 * options.teacherId 老师id
 * options.time 抢课开始时间
 */
export const robCourse = (options) => {
  const parm = {
    pushId: options.courseId,
    start: options.time,
    teaId: options.teacherId,
    source: 3,
  };

  let parmStr = "?";
  Object.keys(parm).map((key) => {
    parmStr = parmStr + key + "=" + parm[key] + "&";
    return null;
  });
  parmStr = parmStr.substring(0, parmStr.length - 1);

  const url = "/api/lesson-service/autoCoursesArrangingService/takeLessons" + parmStr;

  return axios.post(url, {});
};

/**
 * 获取拒绝理由列表
 */
export const getRefuseReasonData = () => {
  return axios.get("/api/lesson-service/autoCoursesArrangingService/getRefuseType", {});
};
